import createTypes from 'redux-create-action-types';

const REQUESTED = 'REQUESTED';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

export const EVENTS = [REQUESTED, SUCCESS, ERROR];

export const STATUS = createTypes(
  'UPDATING',
  'UPDATED',
  'ERROR',
);

export const selectToken = store => (store.session.user.idToken);



// WEBPACK FOOTER //
// ./mobile/shared/api/utils.js